package com.vidaensupalabra.vsp.navigation

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.browser.window
import com.vidaensupalabra.vsp.datos.ComunidadPost

sealed class Screen {
    object Home : Screen()
    object Arde : Screen()
    object Musica : Screen()
    object Information : Screen()
    object Mas : Screen()
    object Donacion : Screen()
    object Multimedia : Screen()
    data class Comunidad(val initialPost: ComunidadPost? = null, val initialPostId: String? = null) : Screen()
    data class Perfil(val userId: String? = null, val userName: String? = null, val userPhoto: String? = null) : Screen()
    data class Devocional(val year: Int, val month: Int, val day: Int) : Screen()
}

object Router {
    var currentScreen by mutableStateOf<Screen>(Screen.Home)
        private set

    private val backStack = mutableListOf<Screen>()

    init {
        // Interceptor de Deep Links (Enlaces Compartidos y Notificaciones)
        val searchParams = org.w3c.dom.url.URLSearchParams(window.location.search)
        val postId = searchParams.get("postId")
        val ardeYear = searchParams.get("ardeYear")?.toIntOrNull()
        val ardeMonth = searchParams.get("ardeMonth")?.toIntOrNull()
        val ardeDay = searchParams.get("ardeDay")?.toIntOrNull()

        if (!postId.isNullOrBlank()) {
            currentScreen = Screen.Comunidad(initialPostId = postId)
        } else if (ardeYear != null && ardeMonth != null && ardeDay != null) {
            currentScreen = Screen.Devocional(ardeYear, ardeMonth, ardeDay)
        }

        // Escucha el evento de la flecha de "Atrás" del celular/navegador
        window.addEventListener("popstate", {
            if (backStack.isNotEmpty()) {
                currentScreen = backStack.removeLast()
            } else {
                currentScreen = Screen.Home
            }
        })
    }

    fun navigateTo(screen: Screen) {
        // Limpia cualquier texto seleccionado para evitar el bug de la lupa en móviles
        window.asDynamic().getSelection()?.removeAllRanges()

        if (currentScreen != screen) {
            backStack.add(currentScreen)
            currentScreen = screen
            // Le decimos al navegador que creamos una nueva "página" en el historial
            window.history.pushState(null, "", "")
        }
    }

    fun goBack() {
        // Limpia la selección de texto también al volver atrás
        window.asDynamic().getSelection()?.removeAllRanges()

        if (backStack.isNotEmpty()) {
            // Esto disparará el evento 'popstate' de arriba automáticamente
            window.history.back()
        } else if (currentScreen != Screen.Home) {
            currentScreen = Screen.Home
        }
    }
}
